<template>
	<div class="multicontent">
		<template v-if="contentData.length == 1 && contentData[0].type == 'emoji'">
			<span class="single-emoji">{{ contentData[0].content }}</span>
		</template>
		<template v-else>
			<q v-if="quote" v-html="checkMentions(quote.content, quote.mentions)"></q>
			<template v-for="(item, index) in trimmedContentData">
				<content-hover v-if="item.type == 'mention'" :user="item.user" :key="'mention-' + index" :hoverClass="mentionClass"/>
				<template v-else-if="item.type == 'url'"  >

					<span v-if="!isFriendly(item.url)" @click="$store.commit('application/showLeave', item.url)"
						:key="'url-' + index"
						class="link text--accent"
						title="Przejdź do adresu url">{{ item.content }}</span>
					<a
						v-else
						:href="item.url"
						:key="'url-friendly-' + index"
						class="link text--accent">
						{{ item.content }}
					</a>
				</template>
				<template v-else-if="item.type == 'break'">
					<br :key="'break-' + index"/>
				</template>
				<template v-else>
					{{ item.content }}
				</template>
			</template>
		</template>
		<span v-if="toShow < contentData.length && !showMore"
			@click="showMore = true"
			text
			dense
			class="readmore">
			{{ $vuetify.lang.t('$vuetify.views.wall.post.readMore') }}
		</span>
		<v-lazy>
			<div class="mt-3" v-if="mainUrl && urlPreview">
				<url-preview :url="mainUrl.url" :small="small"/>
			</div>
		</v-lazy>
	</div>
</template>

<script>
import { decodeMentions, getMentionsClasses } from "@/functions/mentions";
import ContentHover from '@/components/items/ContentHover';
import UrlPreview from '@/components/items/UrlPreview'
import {mapGetters} from 'vuex';
export default {
	components: {
		ContentHover,
		UrlPreview
	},
	props: {
		quote: {
			type: Object,
			default: null
		},
		content: {
			type: [String, Object, Boolean],
			required: true
		},
		mentions: {
			type: Array,
		},
		urlPreview: {
			type: Boolean,
			default: false
		},
		small: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			trimWords: 75,
			showMore: false
		}
	},
	computed: {
		...mapGetters({
			postValidation: 'validation/post'
		}),
		toShow() {
			if(this.trimmedContentData.length != this.contentData.length) {
				return this.trimmedContentData.length;
			}
			return this.contentData.length;
		},
		mentionClass() {
			return getMentionsClasses();
		},
		contentFull() {
			return this.checkMentions(this.content, this.mentions)
		},
		mainUrl() {
			let urls = this.contentData.filter(x => x.type == 'url');
			if(urls.length) {
				return urls[0]
			}
			return null;
		},
		trimmedContentData() {
			if(this.contentData.length) {
				if(this.contentData[this.contentData.length - 1].charCount > this.postValidation.breakAfter) {
					if(!this.showMore) {
						return this.contentData.filter(x => x.charCount <= this.postValidation.breakAfter);
						// return this.contentData.slice(0, this.trimWords);
					}
				}
			}
			return this.contentData;
		},
		contentData() {
			let final = [];
			if(this.content) {
				let c = this.content.replaceAll(/\u00A0/g,' ');
				c = c.replaceAll('\n',' \n ');
				c = c.replaceAll('@:', '@: ');
				c = c.split(' ');
				let arr = c
				let counter = 0;
				arr.forEach(x => {
					if(x != '') {
						counter += x.length;
						if(x == '\n') {
							final.push({
								type: 'break',
								content: '',
								charCount: counter
							});
						}

						else if(x.substr(0,10) == ':@mention=') {
							let id = x.replace(':@mention=','');
							id = id.replace('@:','');
							final.push({
								type: 'mention',
								content: x,
								user: this.getUser(id),
								charCount: counter
							})
						}
						else if(x.substr(0,7) == 'http://' || x.substr(0,8) == 'https://' || x.substr(0,4) == 'www.') {
							let url = x;
							if(x.substr(0,4) == 'www.') {
								url = 'https://' + url;
							}
							final.push({
								type: 'url',
								url: url,
								content: x,
								charCount: counter
							})
						}
						else if(x.length == 2 && this.isEmoji(x)) {
							final.push({
								type: 'emoji',
								content: x,
								length: x.length,
								charCount: counter
							})
						}
						else {
							final.push({
								type: 'string',
								content: x,
								length: x.length,
								charCount: counter
							})
						}
					}
				})
			}
			return final;
		},
		reg() {
			//const regex = new RegExp('<[^/].+?>(.*)[^</]</.+?>',"g");

			let x = this.contentFull.split('<div').join('\n<div');
			x = x.split('</div>').join('</div>'+ '\n');
			// let x = this.contentFull.replaceAll(r, '</div>dupa');
			x = x.split('\n');

			return x;
			/*
			let c = '';
			matches.forEach(m => {
				c = this.contentFull.replace(m, m + 'dupa');
			})
			return c;
			*/
		}
	},
	methods: {
		isFriendly(url) {
			if(url.substring(0, window.location.origin.length) == window.location.origin) {
				return true;
			}
			return false;
		},
		isEmoji(string) {
			const emojiRegex = /\p{Emoji}/u;
			return emojiRegex.test(string); // true
		},
		getUser(id) {
			return this.mentions.find(x => x.id == id);
		},
		checkMentions(val, users) {
			return decodeMentions(val, users)
		},
		/*
		if(this.post.content) {
			this.contentFull = this.checkMentions(this.post.content, this.post.mention_users);
			if(this.contentFull.length > this.trimAfter) {
				this.contentIntro = this.contentFull.substring(0, this.trimAfter);
			}
			else {
				this.contentIntro = '';
			}
		}
		*/
	}
}
</script>

<style lang="scss">
	.single-emoji {
		font-size: 32px;
		line-height: 32px;
	}
</style>>
